import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-add-inventory-window',
  templateUrl: './add-inventory-window.component.html',
  styleUrls: ['./add-inventory-window.component.css']
})
export class AddInventoryWindowComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle('/inventory');
  }

}
